export default "__VITE_ASSET__CqD3n$Fw__"